<template>
    <div class="sidebar">

        <div class="sidebar-backdrop" @click="closeSidebarPanel" v-if="isPanelOpen"></div>

        <transition name="slide">
            <div v-show="isPanelOpen" class="sidebar-panel">
                <div class="cart__head clearfix">
                    <span class="cart__title"><i class="mr-3 fas fa-shopping-cart"></i>WINKELMANDJE</span>
                    <button class="btn btn-sm float-right" @click="closeSidebarPanel"><i class="fa fa-times" aria-hidden="true"></i></button>
                </div>

                <div v-if="items" class="cart__content">
                    <div class="cart__item_wrapper" v-for="(item, index) in items"  v-bind:key="index">
                        <cart-item :item="item"></cart-item>
                    </div>
                </div>

                <div v-if="!items" class="alert alert-warning">
                    <p>Uw winkelmandje is leeg momenteel.</p>
                </div>

                <router-link
                        :to="{name: 'checkout'}"
                        @click.native="closeSidebarPanel"
                        class="btn btn-order btn-primary btn-block">
                    Afronden
                </router-link>
            </div>
        </transition>
    </div>
</template>

<script>
    import { store, mutations } from '@/store.js'
    import Item from './Item'

    export default {
        data() {
            return {
                sidebarActive: true,
                showOverlay: true,
                items: []
            }
        },

        components: {
          'cart-item': Item
        },

        methods: {
            closeSidebarPanel: mutations.toggleNav,

            toggle() {
                mutations.toggleNav();
            },

            getItems() {
                this.$data.showOverlay = true;
                this.items = JSON.parse(localStorage.getItem('products'));
            }
        },

        mounted() {
            this.$root.$on('hide-cart-overlay', () => {
                this.$data.showOverlay = false;
            });

            this.$root.$on('fetch-cart-items', () => {
                this.getItems();
            });

            this.getItems()
        },

        watch: {
            items: {
                handler: function(val) {
                    console.log('Iets?');
                    console.log(val);
                    return val;
                },
                deep: true
            }
        },

        computed: {
            isPanelOpen() {
                return store.isNavOpen
            }
        }
    }
</script>

<style lang="scss">

    .cart__head {
        padding: 1rem 20px 1rem 20px;
        border-bottom: 1px solid #716f6f;

        button {
            border-radius: 0;
            background: none;
            color: #D1AD5A;
            border-color: #D1AD5A;
            text-transform: uppercase;
            &:hover {
                background: #D1AD5A;
                color: white;
            }
        }
        .btn:focus {
            outline: 0;
            box-shadow: none;
        }
    }

    .cart__title {
        font-size: 1.3rem;
        color: #000;
        text-align: center;
    }

    .slide-enter-active,
    .slide-leave-active
    {
        transition: transform 0.2s ease;
    }

    .slide-enter,
    .slide-leave-to {
        transform: translateX(100%);
        transition: all 150ms ease-in 0s;
    }

    .sidebar-backdrop {
        transition: all 150ms ease-in 0s;
        background-color: rgba(0, 0, 0, .55);
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        cursor: pointer;
        z-index: 999;
    }

    .sidebar-panel {
        overflow-y: auto;
        background-color: #FFFFFF;
        color: #d8cdb2;
        position: fixed;
        right: 0;
        top: 0;
        height: 100vh;
        z-index: 9999;
        width: 100%;
        .fa-shopping-cart {
            font-size: 1.2rem;
        }
        @media (min-width: 600px){
            width: 400px;
        }
        @media (min-width: 1200px){
            width: 450px;
        }
        .alert-warning p {
            margin-top: 1rem;
        }
        a {
            font-weight: 500;
            overflow: hidden;
            display: block;
            width: 75%;
            color: white;
            text-decoration: none !important;
            position: absolute;
            bottom: 45px;
            left: 0;
            right: 0;
            margin: auto;
            color: white;
            padding: 15px 25px;
            text-transform: uppercase;
            background: #D1AD5A !important;
            &:hover, &:focus, &:active {
                background: #D1AD5A !important;
                color: white !important;
            }
        }
    }

    .btn-order {
        background: red !important;
    }

</style>